var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.214 8.3335V15.0002H11.5474V8.3335H13.214Z",
    fill: "#CF2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.88053 15.0002V8.3335H8.21387V15.0002H9.88053Z",
    fill: "#CF2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8805 1.6665H6.5472V4.99984H3.21387V6.6665H4.88053V18.3332H16.5472V6.6665H18.2139V4.99984H14.8805V1.6665ZM13.2139 4.99984V3.33317H8.21387V4.99984H13.2139ZM6.5472 6.6665V16.6665H14.8805V6.6665H6.5472Z",
    fill: "#CF2A2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d459bee71932afedc016bf477a27bcb4.svg";
export { ForwardRef as ReactComponent };